import { render, staticRenderFns } from "./DashboardLoader.vue?vue&type=template&id=624db672&scoped=true"
import script from "./DashboardLoader.vue?vue&type=script&lang=js"
export * from "./DashboardLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624db672",
  null
  
)

export default component.exports